import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect, useState } from 'react';
import { usePopper } from 'react-popper';
import './Popper.css';
export let Placements = /*#__PURE__*/function (Placements) {
  Placements["Auto"] = "auto";
  Placements["AutoStart"] = "auto-start";
  Placements["AutoEnd"] = "auto-end";
  Placements["Top"] = "top";
  Placements["TopStart"] = "top-start";
  Placements["TopEnd"] = "top-end";
  Placements["Bottom"] = "bottom";
  Placements["BottomStart"] = "bottom-start";
  Placements["BottomEnd"] = "bottom-end";
  Placements["Right"] = "right";
  Placements["RightStart"] = "right-start";
  Placements["RightEnd"] = "right-end";
  Placements["Left"] = "left";
  Placements["LeftStart"] = "left-start";
  Placements["LeftEnd"] = "left-end";
  return Placements;
}({});
const Popper = props => {
  const {
    arrowClasses = 'w-2 h-2',
    children,
    hideContent = () => undefined,
    hideOnOutsideClick = true,
    hideOnResize = true,
    hideOnScroll = true,
    flipOptions = null,
    offset = [0, 8],
    placement = Placements.Auto,
    popperClasses = 'bg-white',
    showArrow = true,
    showContent = true,
    triggerElement,
    strategy
  } = props;
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);

  /**
   * Popper comes with a lot of simple and advanced customizations via
   * modifiers.
   *
   * See https://popper.js.org/docs/v2/modifiers
   */
  const formPopperModifiers = () => {
    const modifiers = [];
    if (showArrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: arrowElement
        }
      });
    }
    if (offset) {
      modifiers.push({
        name: 'offset',
        options: {
          offset
        }
      });
    }
    if (flipOptions) {
      modifiers.push({
        name: 'flip',
        options: flipOptions
      });
    }
    return modifiers;
  };
  const {
    styles,
    attributes
  } = usePopper(referenceElement, popperElement, {
    placement,
    strategy,
    modifiers: formPopperModifiers()
  });
  const handleClick = e => {
    if (showContent && !(popperElement !== null && popperElement !== void 0 && popperElement.contains(e.target)) && !(referenceElement !== null && referenceElement !== void 0 && referenceElement.contains(e.target))) {
      hideContent();
    }
  };
  const handleMouseDown = e => {
    if (showContent && (popperElement !== null && popperElement !== void 0 && popperElement.contains(e.target) || referenceElement !== null && referenceElement !== void 0 && referenceElement.contains(e.target))) {
      e.preventDefault();
    }
  };
  useEffect(() => {
    window.addEventListener('mousedown', handleMouseDown);
    if (hideOnOutsideClick) {
      window.addEventListener('click', handleClick);
    }
    if (hideOnResize) {
      window.addEventListener('resize', hideContent);
    }
    if (hideOnScroll) {
      document.addEventListener('scroll', hideContent);
    }
    return () => {
      window.removeEventListener('mousedown', handleMouseDown);
      if (hideOnOutsideClick) {
        window.removeEventListener('click', handleClick);
      }
      if (hideOnResize) {
        window.removeEventListener('resize', hideContent);
      }
      if (hideOnScroll) {
        document.removeEventListener('scroll', hideContent);
      }
    };
  }, [popperElement]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, triggerElement(setReferenceElement), showContent && /*#__PURE__*/React.createElement("div", _extends({
    className: `z-10 ${popperClasses}`,
    id: "popper",
    ref: setPopperElement,
    style: styles.popper
  }, attributes.popper), children, showArrow && /*#__PURE__*/React.createElement("div", {
    className: `invisible shadow-popover z-20 ${arrowClasses}`,
    id: "popper-arrow",
    ref: setArrowElement,
    style: styles.arrow
  })));
};
export default Popper;